import React, { useEffect, useState } from "react";
import UserPageLayout from "../../../../components/UserPageLayout";
import { useAppContext } from "../../../../../../context/AppContext";
import ArticleList from "../../components/ArticleList";
import ArticleForm from "../../components/ArticleForm";


export default function Articles() {
    const { setPageTitle, setPageUserID } = useAppContext();
    const [editMode, setEditMode] = useState(false);
    const [selectedArticle, setSelectedArticle] = useState(null);

    useEffect(() => {
        setPageUserID(null);
        setPageTitle(!editMode  ? "Articles" : "Article Editor") ;
    }, [editMode, setPageTitle, setPageUserID]);
    
    return (
        <UserPageLayout>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            {
                              !editMode ? (
                                <ArticleList setEditMode={setEditMode} selectedArticle={selectedArticle} setSelectedArticle={setSelectedArticle} />
                              ) : (
                                <ArticleForm setEditMode={setEditMode} selectedArticle={selectedArticle} />
                              )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </UserPageLayout>
    );
}